import {XauditModel} from '../../xaudit.model';
import {TdoUserInGroupConfigurationModel} from './tdo-user-in-group-configuration.model';
import {TdoUserLocationConfigurationModel} from './tdo-user-location-configuration.model';

export class TdoUserConfigurationModel extends XauditModel {
  ContactId: string;
  FirstName: string;
  LastName: string;
  MidName: string;
  TDOCID: number;
  UserID: string;
  UserName: string;
  UserNickName: string;
  cfgTDOUserInGroups: TdoUserInGroupConfigurationModel[];
  cfgTDOuserLocations: TdoUserLocationConfigurationModel[];
  enumSalutationID: string;
  WorkStationID: string;
  userid: string;
  ColorSchemeID: string;
  UserSound: string;
  IconSVG: string;  
  ERxParametersJSON:  string = '';
}
